export default [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('../../pages/dashboard/IndexPage.vue'),
        meta: {
            title: 'Dashboard',
            requiresAuth: true,
        },
    },
]
